module.exports = __webpack_public_path__ + "fonts/BebasNeue-Regular.b2b2930.ttf";